import React from 'react';
import { useTranslation } from 'react-i18next';
import '../Checkout.css';

export interface ShippingAddress {
  firstName: string;
  lastName: string;
  address: string;
  apartment: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  phone: string;
}

interface ShippingSectionProps {
  shippingAddress: ShippingAddress;
  shippingMethod: string;
  errors: { [key: string]: string };
  onShippingChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onShippingMethodChange: (method: string) => void;
}

const ShippingSection: React.FC<ShippingSectionProps> = ({
  shippingAddress,
  shippingMethod,
  errors,
  onShippingChange,
  onShippingMethodChange
}) => {
  const { t } = useTranslation();

  return (
    <div className="checkout-step">
      <h2>{t('checkout.shippingAddress')}</h2>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="firstName">{t('checkout.firstName')} *</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={shippingAddress.firstName}
            onChange={onShippingChange}
            className={errors.firstName ? 'error' : ''}
            placeholder={t('checkout.enterFirstName')}
          />
          {errors.firstName && <span className="error-message">{errors.firstName}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="lastName">{t('checkout.lastName')} *</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={shippingAddress.lastName}
            onChange={onShippingChange}
            className={errors.lastName ? 'error' : ''}
            placeholder={t('checkout.enterLastName')}
          />
          {errors.lastName && <span className="error-message">{errors.lastName}</span>}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="address">{t('checkout.address')} *</label>
        <input
          type="text"
          id="address"
          name="address"
          value={shippingAddress.address}
          onChange={onShippingChange}
          className={errors.address ? 'error' : ''}
          placeholder={t('checkout.streetAddress')}
        />
        {errors.address && <span className="error-message">{errors.address}</span>}
      </div>

      <div className="form-group">
        <label htmlFor="apartment">{t('checkout.apartment')}</label>
        <input
          type="text"
          id="apartment"
          name="apartment"
          value={shippingAddress.apartment}
          onChange={onShippingChange}
          placeholder={t('checkout.apartmentPlaceholder')}
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label htmlFor="city">{t('checkout.city')} *</label>
          <input
            type="text"
            id="city"
            name="city"
            value={shippingAddress.city}
            onChange={onShippingChange}
            className={errors.city ? 'error' : ''}
            placeholder={t('checkout.enterCity')}
          />
          {errors.city && <span className="error-message">{errors.city}</span>}
        </div>
        <div className="form-group">
          <label htmlFor="zipCode">{t('checkout.zipCode')} *</label>
          <input
            type="text"
            id="zipCode"
            name="zipCode"
            value={shippingAddress.zipCode}
            onChange={onShippingChange}
            className={errors.zipCode ? 'error' : ''}
            placeholder="1234567"
            maxLength={7}
          />
          {errors.zipCode && <span className="error-message">{errors.zipCode}</span>}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="phone">{t('checkout.phoneNumber')} *</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={shippingAddress.phone}
          onChange={onShippingChange}
          className={errors.phone ? 'error' : ''}
          placeholder="050-1234567"
        />
        {errors.phone && <span className="error-message">{errors.phone}</span>}
      </div>

      <div className="form-group">
        <label htmlFor="country">{t('checkout.country')}</label>
        <select
          id="country"
          name="country"
          value={shippingAddress.country}
          onChange={onShippingChange}
          disabled
        >
          <option value="IL">ישראל (Israel)</option>
        </select>
        <p className="shipping-note" style={{ fontSize: '14px', color: '#6c757d', marginTop: '8px' }}>
          {t('checkout.shippingToIsraelOnly')}
        </p>
      </div>


    
    </div>
  );
};

export default ShippingSection;

